import {
  BetType,
  OrderDetailStatus,
  OrderSingleRace,
} from '@/lib/apollo/types/gen/graphql';

import { parseOddsInfo } from './odds';

export type OrderDetail = {
  isHit: boolean;
  isSpecialPayment: boolean;
  isReturned: boolean;
  isRefunded: boolean;
  totalBetAmount: number;
  totalRefund: number;
  betType: BetType;
  setNums: number[];
};

export type OrderData = { [key in BetType]: OrderDetail[] };

export const parsedOrderData = (orders: OrderSingleRace[]) => {
  const orderData = {} as OrderData;
  Object.entries(BetType).forEach(([_, type]) => {
    orderData[type] = [];
  });

  orders.forEach(order => {
    order.details.forEach(d => {
      const index = orderData[d.betType].findIndex(
        od => od.setNums[0] === Number(d.numbers.join('')),
      );
      if (index >= 0) {
        orderData[d.betType][index].totalBetAmount += d.amount;
        orderData[d.betType][index].totalRefund += d.refund;
      } else {
        orderData[d.betType].push({
          isHit: d.status === OrderDetailStatus.Hit,
          isSpecialPayment: d.status === OrderDetailStatus.SpecialPayment,
          isReturned: d.status === OrderDetailStatus.Return,
          isRefunded: d.status !== OrderDetailStatus.Undecided,
          totalBetAmount: d.amount,
          totalRefund: d.refund,
          betType: d.betType,
          setNums: [Number(d.numbers.join(''))],
        } as OrderDetail);
      }
    });
  });

  return orderData;
};

export const getOddsData = (order: OrderSingleRace) =>
  order.race.odds ? parseOddsInfo(order.race.odds.oddsInfo) : null;
